/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */

import styled from 'styled-components'

export const ButtonWrapper = styled.div`
	text-align: center;
`

export const TreatedUnitWrapper = styled.div`
	display: flex;
	padding: 0.5rem 0;
	justify-content: space-between;
`
